export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10242.23a2ff90.jpg";